var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Chromecast = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.tag.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return null
  },

  /** Override to return Frames Per Secon (FPS) */
  getFramesPerSecond: function () {
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.tag.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    try {
      if (this.player.getStreamingProtocol) {
        var protocol = this.player.getStreamingProtocol()
        for (var c = 0; c < protocol.getStreamCount(); c++) {
          var streamInfo = protocol.getStreamInfo(c)
          if (streamInfo.mimeType.indexOf('video/') === 0) {
            var videoLevel = protocol.getQualityLevel(c)
            if (streamInfo.bitrates && streamInfo.bitrates[videoLevel]) {
              return streamInfo.bitrates[videoLevel]
            }
          }
        }
      }
      return null // No video stream available
    } catch (err) {
      return null // Stream info not available yet, do nothing
    }
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    var bitrate = this.getBitrate()
    return bitrate > 0 ? Util.buildRenditionString(bitrate) : null
  },

  /** Override to return title */
  getTitle: function () {
    return null
  },

  /** Override to return title2 */
  getTitle2: function () {
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (!this.tag.currentSrc.startsWith("blob:")) {
      return this.tag.currentSrc
    } else if (this.player) {
      return this.player.getHost().url
    } else {
      return "unknown"
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (cast && cast.player && cast.player.api && cast.player.api.VERSION) {
      return "Chromecast " + cast.player.api.VERSION
    } else {
      return "Chromecast"
    }
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Chromecast"
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    return null
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    this.tag = document.getElementsByTagName('video')[0]

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.tag.addEventListener('loadstart', this.playListener.bind(this))
    this.tag.addEventListener('pause', this.pauseListener.bind(this))
    this.tag.addEventListener('playing', this.playingListener.bind(this))
    this.tag.addEventListener('error', this.errorListener.bind(this))
    this.tag.addEventListener('seeking', this.seekingListener.bind(this))
    this.tag.addEventListener('abort', this.endedListener.bind(this))
    this.tag.addEventListener('ended', this.endedListener.bind(this))
  },

  /** Unregister listeners to this.tag. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.tag.removeEventListener('loadstart', this.playListener)
    this.tag.removeEventListener('pause', this.pauseListener)
    this.tag.removeEventListener('playing', this.playingListener)
    this.tag.removeEventListener('error', this.errorListener)
    this.tag.removeEventListener('seeking', this.seekingListener)
    this.tag.removeEventListener('abort', this.endedListener)
    this.tag.removeEventListener('ended', this.endedListener)
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) { // ?
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e)
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    this.fireBufferBegin()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  }
})

module.exports = youbora.adapters.Chromecast



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 24
// module chunks = 0